import { RegisteredComponent } from "@builder.io/sdk-react";

export const tabPanelsBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Tab Panels",
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/icon-library-of-x-bacteria/tab-9.png",
  requiresParent: {
    message: "This component must be nested within a tab component",
    query: {
      "component.name": {
        $in: ["Horizontal Tab"],
      },
    },
  },
  defaultStyles: {
    width: "100%",
  },
  inputs: [
    {
      name: "animation",
      type: "select",
      friendlyName: "Animation",
      defaultValue: "none",
      enum: ["none", "slide", "fade", "fadeInUp"],
    },
  ],
};
